import { render, staticRenderFns } from "./BaseSettings.vue?vue&type=template&id=23fec1e9&scoped=true"
import script from "./BaseSettings.vue?vue&type=script&lang=js"
export * from "./BaseSettings.vue?vue&type=script&lang=js"
import style0 from "./BaseSettings.vue?vue&type=style&index=0&id=23fec1e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fec1e9",
  null
  
)

export default component.exports